/* global HTMLIFrameElement */ function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import APISession from "./APISession";
var ExtensionAPI = /*#__PURE__*/ function() {
    "use strict";
    function ExtensionAPI(bridge) {
        _classCallCheck(this, ExtensionAPI);
        if (!bridge) {
            throw new Error("ExtensionAPI Error: You have to support a Bridge e.g new ExtensionAPI(bridge)");
        }
        this._bridge = bridge;
        this._sessions = [];
    }
    var _proto = ExtensionAPI.prototype;
    _proto.createSession = function createSession() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            type: "frontend"
        };
        var session = new APISession(options, this._bridge);
        this._sessions.push(session);
        return session;
    };
    _proto.removeSession = function removeSession(session) {
        if (!_instanceof(session, APISession) && typeof session !== "string") {
            throw new Error("ExtensionAPI Error: You have to submit an APISession or a valid session id");
        }
        var _id = typeof session === "string" ? session : session.id;
        var _session = this._sessions.find(function(s) {
            return s.id === _id;
        });
        if (_session) {
            _session.cleanup();
            this._sessions.splice(this._sessions.indexOf(_session), 1);
        } else {
            throw new Error("ExtensionAPI Error: Session could not be found");
        }
    };
    _proto.removeSessionsByFrame = function removeSessionsByFrame(frame) {
        var _this = this;
        if (!_instanceof(frame, HTMLIFrameElement)) {
            console.warn("ExtensionAPI Error: You have to submit an valid HTMLIFrameElement to remove Sessions");
            return;
        }
        this._sessions.filter(function(_s) {
            return _s.frame === frame;
        }).forEach(function(_s) {
            return _this.removeSession(_s);
        });
    };
    _proto.triggerEvent = function triggerEvent(name, payload, scope) {
        this._sessions.forEach(function(s) {
            return s.fire(name, payload, scope);
        });
    };
    return ExtensionAPI;
}();
export { ExtensionAPI as default };
